import axios from '../../../axios';
import * as permissions from '../../../../const/permissions';
import store from '../../../../store/store.js';
import userModifier from '../../../../modifiers/pengguna';

export default {
  async loginWithUsername({ username, password }) {
    try {
      const response = await axios.post('/auth/login', {
        username,
        password,
      });
      const data = await response.data;
      if (!data) throw new Error('Login failed');
      const token = data.data.token;
      const user = data.data.user;
      this.setAuth({ token, user });
      this.setUserInfoToState(data.data.user);
      this.setUserToState();
      return data;
    } catch (error) {
      return null;
    }
  },

  setAuth({ token, user }) {
    localStorage.setItem('token', JSON.stringify(token));
    localStorage.setItem('user', JSON.stringify(user));
  },

  setUserToState(user = userModifier(this.getUser())) {
    store.dispatch('updateUser', user);
  },

  setUserInfoToState(data) {
    const payload = {
      uid: data.id,
      displayName: data.nama,
      about:
        'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
      photoURL: require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
      status: 'online',
      userRole: 'admin',
    };
    store.dispatch('updateUserInfo', payload);
  },

  isAuth() {
    return Boolean(this.getToken() && this.getUser());
  },

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  },

  getToken() {
    return JSON.parse(localStorage.getItem('token'));
  },

  logout() {
    localStorage.clear('token');
    localStorage.clear('user');
    this.setUserToState(null);
  },

  canCreateSuratMasuk() {
    return permissions.canCreateSuratMasuk(this.getUser().role);
  },

  canParallelDisposition() {
    return permissions.canParallelDisposition(this.getUser().role);
  },

  canParafDisposition() {
    return permissions.canParafDisposition(this.getUser().role);
  },

  isHeadPosition() {
    return permissions.isHeadPosition(this.getUser().role);
  },
  canCreateSuratKeluar() {
    return permissions.canCreateSuratKeluar(this.getUser().role);
  },
};
